import React from 'react';
import { ExternalLink, TrendingUp, MapPin, Clock } from 'lucide-react';

const PersonalizedAds = ({ ads, userProfile }) => {
  if (!ads || ads.length === 0) {
    return null;
  }

  const getCategoryIcon = (category) => {
    switch (category) {
      case 'transport':
        return <TrendingUp className="w-5 h-5" />;
      case 'food':
        return <span className="text-lg">🍽️</span>;
      case 'exploration':
        return <MapPin className="w-5 h-5" />;
      case 'outdoor':
        return <span className="text-lg">🏔️</span>;
      default:
        return <ExternalLink className="w-5 h-5" />;
    }
  };

  const getCategoryColor = (category) => {
    switch (category) {
      case 'transport':
        return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'food':
        return 'bg-orange-100 text-orange-800 border-orange-200';
      case 'exploration':
        return 'bg-green-100 text-green-800 border-green-200';
      case 'outdoor':
        return 'bg-purple-100 text-purple-800 border-purple-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Personalized for You</h3>
        <div className="flex items-center space-x-1 text-sm text-gray-500">
          <Clock className="w-4 h-4" />
          <span>Based on your activity</span>
        </div>
      </div>

      <div className="space-y-4">
        {ads.map((ad) => (
          <div
            key={ad.id}
            className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow cursor-pointer"
            onClick={() => window.open(ad.actionUrl, '_blank')}
          >
            <div className="flex items-start space-x-3">
              {/* Icon */}
              <div className={`p-2 rounded-lg border ${getCategoryColor(ad.category)}`}>
                {getCategoryIcon(ad.category)}
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-semibold text-gray-900 mb-1">
                  {ad.title}
                </h4>
                <p className="text-sm text-gray-600 mb-2">
                  {ad.description}
                </p>
                
                {/* Category badge */}
                <div className="flex items-center space-x-2">
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${getCategoryColor(ad.category)}`}>
                    {ad.category}
                  </span>
                  {ad.type === 'local_business' && (
                    <span className="text-xs text-gray-500">Local Business</span>
                  )}
                </div>
              </div>

              {/* Action indicator */}
              <div className="flex-shrink-0">
                <ExternalLink className="w-4 h-4 text-gray-400" />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* User profile insights */}
      {userProfile && (
        <div className="mt-4 pt-4 border-t border-gray-200">
          <div className="flex items-center justify-between text-sm text-gray-600">
            <span>Your primary transport: <strong>{userProfile.primaryTransportMode}</strong></span>
            <span>{userProfile.totalVisits} frequent areas</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default PersonalizedAds;
